module.exports = __webpack_public_path__ + "img/fail-page-title.850de62e.png";